import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkout--delivery-form"
export default class extends Controller {
  static targets = ["method", "submitButton"]

  connect() { this.#updateSubmitState() }
  methodChanged() { this.#updateSubmitState() }
  parcelshopSelected() { this.#updateSubmitState() }

  #updateSubmitState() {
    const selected = this.methodTargets.find(m => m.checked)
    if (!selected) { this.submitButtonTarget.disabled = true; return }

    const card = selected.closest("[data-delivery-form-method-card]")
    const requiresPickup = card?.dataset.requiresPickupPoint === "true"
    if (!requiresPickup) { this.submitButtonTarget.disabled = false; return }

    const pickupInput = card.querySelector(
      'input[name$="[provider_numeric_id]"]'
    )
    this.submitButtonTarget.disabled = !pickupInput?.value
  }
}
